module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.stripsItem) ? _c('div', {
    key: "relatedItem",
    staticClass: "modal-mask",
    attrs: {
      "id": "related-item"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../assets/croix.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.close();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modalBody"
  }, [_c('h2', {
    staticClass: "ff-medium uppercase"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "selectContainer"
    }
  }, [_c('multiselect', {
    staticClass: "uppercase",
    attrs: {
      "id": "addRelatedItem",
      "options": _vm.options,
      "multiple": true,
      "preserve-search": true,
      "placeholder": "Rechercher",
      "label": "name",
      "track-by": "name",
      "exact": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flexContainer jc-sb"
  }, [_c('button', {
    staticClass: "btn uppercase pointer ff-light",
    on: {
      "click": function($event) {
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn uppercase pointer ff-light",
    on: {
      "click": function($event) {
        _vm.saveRelatedItem();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15efd468","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modalStrips.vue
// module id = 3033
// module chunks = 0